import Tmdb from "../../services/tmdb";

const tmdb = new Tmdb();

export const FETCH_POPULAR_REQUESTED = "FETCH_POPULAR_REQUESTED";
export const POPULAR_LOADED = "POPULAR_LOADED";
export const POPULAR_ERROR = "POPULAR_LOADED";
export const LOAD_MORE_REQUESTED = "LOAD_MORE_REQUESTED";
export const LOAD_MORE = "LOAD_MORE";

export const popularRequested = () => {
  return {
    type: FETCH_POPULAR_REQUESTED
  };
};

export const popularLoaded = movies => {
  return {
    type: POPULAR_LOADED,
    payload: movies
  };
};

export const popularMoreLoaded = movies => {
  return {
    type: LOAD_MORE,
    payload: movies
  };
};

export const moreLoadRequested = () => {
  return {
    type: LOAD_MORE_REQUESTED
  };
};

export const popularError = () => {
  return {
    type: POPULAR_ERROR
  };
};

export const loadMore = page => {
  return dispatch => {
    dispatch(moreLoadRequested());
    tmdb
      .getPopularMovies(page)
      .then(data => dispatch(popularMoreLoaded(data)))
      .catch(() => dispatch(popularError()));
  };
};

export const fetchPopularMovies = page => {
  return dispatch => {
    dispatch(popularRequested());
    tmdb
      .getPopularMovies(page)
      .then(data => dispatch(popularLoaded(data)))
      .catch(() => dispatch(popularError()));
  };
};
